import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import FontSettings from './FontSettings';
import PaddingSettings from './PaddingSettings';
import HorizontalRule from '../../../../componentLibrary/HorizontalRule';
import * as Styled from '../styles';
import { blockType } from '../../../../types';
import elementTypes from '../../../../constants/elementTypes';


class MultipleElementsSetting extends PureComponent {
    state = {
        selectedElements: undefined,
        renderAllSettings: true,
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        const { canvasBlocks, selectedElements } = nextProps;
        const renderAll = !Object.values(selectedElements.local).some((el) => el.type !== elementTypes.PARAGRAPH && el.type !== elementTypes.BUTTON);
        return { ...prevState, canvasBlocks, selectedElements, renderAllSettings: renderAll };
    }

    render() {
        const { renderAllSettings, selectedElements, canvasBlocks } = this.state;
        let fontSettings;

        if (renderAllSettings) {
            fontSettings =
                <FontSettings selectedElements={selectedElements} canvasBlocks={canvasBlocks} />;
        } else {
            fontSettings = <React.Fragment />;
        }

        return (
            <div>
                <Styled.Row>
                    <HorizontalRule />
                    <PaddingSettings selectedElements={selectedElements} canvasBlocks={canvasBlocks} />
                    {fontSettings}
                </Styled.Row>
            </div>
        );
    }
}

MultipleElementsSetting.propTypes = {
    canvasBlocks: PropTypes.arrayOf(blockType).isRequired,
    selectedElements: PropTypes.shape({
        local: PropTypes.object,
        remote: PropTypes.object,
    }).isRequired,
};

const mapStateToProps = (state) => ({
    canvasBlocks: state.canvasBlocks.present,
    selectedElements: state.selectedElements,
});

export default connect(mapStateToProps)(MultipleElementsSetting);
